import { Action, Badge, Card, OrderLineItem } from 'corso-admin-ui';
import { CrewClaimResolutionMethodEnum } from 'corso-types';
import { Key } from 'react';
import ResolutionMethodBadge from '~/components/ResolutionMethodBadge';

// we really need a universal reusable line item type
type ExchangeOrderLineItem = {
  id: Key;
  name: string | null;
  imgUrl: string | null;
  quantity: number;
  optionsFromPlatform: {
    value: string;
    name: string;
  }[];
  unitPrice: number | null;
  unitTax: number | null;
  sku?: string | null;
};

type ExchangeOrder = {
  id: Key;
  orderNameFromPlatform?: string;
  platformAdminUrl?: string;
  lineItems: ExchangeOrderLineItem[];
  containsShopNowItems: boolean;
  wasResolvedExternally: boolean;
  isOriginalOrder: boolean;
};

// TODO: potentially add a new state for "added to order items"
export function ExchangeOrderLine({ order }: { order: ExchangeOrder }) {
  return (
    <section className="space-y-2">
      <Card.Line>
        <div className="flex items-center gap-2 sm:justify-between">
          <ResolutionMethodBadge
            resolutionMethod={CrewClaimResolutionMethodEnum.replacementOrder}
            icon
          >
            {' '}
            <span>
              (
              {order.lineItems.reduce(
                (total, item) => total + item.quantity,
                0,
              )}
              )
            </span>
          </ResolutionMethodBadge>
          {order.containsShopNowItems && <Badge variant="info">Shop Now</Badge>}
          {order.wasResolvedExternally && <Badge>Resolved Outside Corso</Badge>}
          {order.isOriginalOrder && <Badge>Added To Original Order</Badge>}
        </div>
        {order.platformAdminUrl && (
          <Action
            to={order.platformAdminUrl}
            target="_blank"
            variant="link"
            icon="shopify"
            className="text-xs"
          >
            {order.orderNameFromPlatform ?? 'View Order'}
          </Action>
        )}
      </Card.Line>

      <ul className="space-y-3 py-2">
        {order.lineItems.map((lineItem) => (
          <li key={lineItem.id}>
            <OrderLineItem
              size="sm"
              title={lineItem.name}
              src={lineItem.imgUrl}
              quantity={lineItem.quantity}
              options={lineItem.optionsFromPlatform}
              sku={lineItem.sku}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}
